import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProductCategoryValuesModel } from '@warema/shared/company-search/models';
import { ProductCategoriesValues } from '@warema/shared/product-category';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductCategoryState } from '../state/product-category.reducers';
import * as ProductCategorySelectors from '../state/product-category.selectors';

@Injectable({
    providedIn: 'root',
})
export class ProductCategoryTrackingService {
    private readonly _store = inject<Store<ProductCategoryState>>(Store);

    public selectedSubProductCategoriesIds$: Observable<Array<number>>;

    constructor() {
        this.selectedSubProductCategoriesIds$ = this._store.select(
            ProductCategorySelectors.selectAllSelectedProductCategoriesIds,
        );
    }

    public getSelectedProductCategoriesWithGoalValue(): Observable<{
        categories: Array<ProductCategoryValuesModel>;
        goalValue: number;
    }> {
        return this.selectedSubProductCategoriesIds$.pipe(
            map(ids => ({
                categories: this._getFilteredCategories(ids),
                goalValue: this._getGoalValue(ids),
            })),
        );
    }

    private _getFilteredCategories(ids: Array<number>): Array<ProductCategoryValuesModel> {
        return ProductCategoriesValues.filter(category => ids.includes(category.productCategoryId));
    }

    private _getGoalValue(ids: Array<number>): number {
        return ProductCategoriesValues.filter(x => ids.includes(x.productCategoryId)).reduce(
            (acc, g) => acc + g.value,
            0,
        );
    }
}
